/**
 * アセット情報
 */
const Assets = {
    /**
     * エラー画像
     */
    ERROR_IMAGE: '/img/error.svg',

    /**
     * デフォルト著者画像
     */
    DEFAULT_AUTHOR_IMAGE: '/img/author-image.png',
}

export default Assets;